import {
  TableField,
  defaultCPFFormatter,
  defaultInativoFormatter,
} from "../../table-field";

// campos da lista atual (java) são login, nome, cpf, email, inativo, ações
const nome: TableField = {
  key: "NOME",
  label: "Nome",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const cpf: TableField = {
  key: "CPF",
  label: "CPF",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
  formatter: defaultCPFFormatter,
};
const email: TableField = {
  key: "EMAIL",
  label: "E-mail",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const situacao: TableField = {
  key: "INATIVO",
  label: "Situação",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
  formatter: defaultInativoFormatter,
};
const perfis: TableField = {
  key: "USUARIO_PERFIL[0].perfil.Descricao",
  label: "Perfis",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};

const actions = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions"],
  thClass: "text-center",
  sortable: false,
};

export const fieldsConsultaUsuarios: TableField[] = [
  nome,
  cpf,
  email,
  situacao,
  actions,
];

export const fieldsConsultaUsuariosPorUg: TableField[] = [
  nome,
  cpf,
  perfis,
  actions,
];
